import { isUndefinedOrNullOrEmptyString } from '../../validators';

export const requiredCheck  = {
  type: 'error',
  condition: isUndefinedOrNullOrEmptyString,
  label: 'This field is required.',
  checkOnChange: true,
};



// WEBPACK FOOTER //
// ./src/entities/enterprise-users/shared.js